export default __webpack_public_path__ + "static/media/camryhybrid.a34977ed.png";